import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=2f8f3b1e&"
import script from "./UserModal.vue?vue&type=script&lang=js&"
export * from "./UserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports